import { checkUserHasRole } from "../auth/Utils";
import { helpContent } from "./content";
import { publishedContent } from "./manifest";
import { guidePath } from "./actions";

// IDs and anchors are public editorial destinations, never copied from app URLs.
const general = [["first-answer"], ["marked-answer"], ["class-insights"]];
const routeGuides = [
  [/^\/account(?:\/|$)/, [["first-answer", "typing-settings"]]],
  [/^\/assistant(?:\/|$)/, [["ask-bud"]]],
  [/^\/quizzes\/create(?:\/|$)/, [["first-quiz"], ["ask-bud", "quiz"]]],
  [/^\/quizzes(?:\/|$)/, [["first-quiz"]]],
  [
    /^\/assignments\/(?:answer\/upload|upload|submission-hub)(?:\/|$)/,
    [["first-answer", "upload-link"]],
  ],
  [/^\/assignments\/answer\/view(?:\/|$)/, [["marked-answer"]]],
  [
    /^\/assignments\/create(?:\/|$)/,
    [
      ["first-answer", "upload-questions"],
      ["ask-bud", "assignment"],
    ],
  ],
  [/^\/questions(?:\/|$)/, [["first-answer", "upload-questions"]]],
  [
    /^\/(?:school\/classes|management\/classes)(?:\/|$)/,
    [["first-answer", "class"], ["class-insights"]],
  ],
  [
    /^\/assignments\/view\/[^/]+\/questions\/view(?:\/|$)/,
    [["first-answer", "upload-link"], ["marked-answer"]],
  ],
];

export function contextualGuides(pathname, user, entries = helpContent) {
  const role = user?.info?.activeContext?.roleAssignment?.role?.code;
  if (
    !user?.isLoggedIn ||
    !role ||
    !["teacher", "admin", "director_of_learning"].some((r) =>
      checkUserHasRole({ user, role: r }),
    )
  )
    return [];
  const path = (pathname || "/").split(/[?#]/)[0];
  const selections =
    routeGuides.find(([pattern]) => pattern.test(path))?.[1] || general;
  const published = publishedContent(entries);
  return selections.flatMap(([id, anchor]) => {
    const guide = published.find((entry) => entry.id === id);
    if (!guide) return [];
    const step = guide.steps.find((item) => item.id === anchor);
    return [
      {
        ...guide,
        href: `${guidePath(guide)}${step ? `#${step.id}` : ""}`,
        stepTitle: step?.title,
      },
    ];
  });
}

export function canOpenQuickStart(user) {
  const context = user?.info?.activeContext;
  const role = context?.roleAssignment;
  return Boolean(
    user?.isLoggedIn &&
      user.info?.subscribed &&
      role?.role?.code === "teacher" &&
      checkUserHasRole({ user, role: "teacher" }) &&
      context.hasApprovedSubscription === false &&
      role.subjects?.length &&
      role.educationLevels?.length,
  );
}

// Token refresh should not reset an open draft; account/context switches must.
export function helpOwner(user) {
  const context = user?.info?.activeContext;
  const role = context?.roleAssignment;
  return JSON.stringify([
    user?.isLoggedIn,
    user?.info?.id,
    user?.beingImpersonated,
    context?.contextType,
    role?.id,
    role?.role?.code,
    role?.school?.id,
    role?.schoolGroup?.id,
  ]);
}
